export default "__VITE_ASSET__b2381abe__"